import {state, style, transition, animate, trigger, AUTO_STYLE} from '@angular/animations';
import {Component, OnInit, ViewEncapsulation,} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { ChangePasswordService } from '../authentication/change-password/change-password.service';
import { AutenticacionService } from '../seguridad/autenticacion.service';
import { SettingService } from '../nucleo/configuracion/setting.service';
import { MenuItems } from '../shared/menu-items/menu-items';
import { Constante } from '../nucleo/constante/constante';

export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('mobileMenuTop', [
        state('no-block, void',
            style({
                overflow: 'hidden',
                height: '0px',
            })
        ),
        state('yes-block',
            style({
                height: AUTO_STYLE,
            })
        ),
        transition('no-block <=> yes-block', [
            animate('400ms ease-in-out')
        ])
    ])
  ]
})

export class AdminLayoutComponent implements OnInit {
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  innerHeight: string;
  isCollapsedMobile = 'no-block';
  isCollapsedSideBar = 'no-block';
  toggleOn = true;
  windowWidth: number;

  constructor(public menuItems: MenuItems, public loginService: AutenticacionService
             ,private router: Router,private toastr: ToastrService
             ,private settingService: SettingService
             ,private changePwdService: ChangePasswordService) {
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
  }

  ngOnInit() {}

  onClickedOutside(e: Event) {
      if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
          this.toggleOn = true;
          this.verticalNavType = 'offcanvas';
      }
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
      if (windowWidth >= 768 && windowWidth <= 1024) {
        this.deviceType = 'tablet';
        //this.verticalNavType = 'collapsed';
        this.verticalNavType = '';
        this.verticalEffect = 'push';
      } else if (windowWidth < 768) {
        this.deviceType = 'mobile';
        //this.verticalNavType = 'offcanvas';
        this.verticalNavType = '';
        this.verticalEffect = 'overlay';
      } else {
        this.deviceType = 'desktop';
        //this.verticalNavType = 'expanded';
        this.verticalNavType = '';
        this.verticalEffect = 'shrink';
      }
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
        this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
        this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
        //this.verticalNavType = this.verticalNavType === 'expanded' ? 'collapsed' : 'expanded';
        this.verticalNavType = '';
    }
  }

  toggleOpenedSidebar() {
    this.isCollapsedSideBar = this.isCollapsedSideBar === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }

  logout() {
    this.loginService.logout({usrLogin: this.loginService.obtenerUsuario()}).subscribe(response => {
      if(response.codigo === Constante.RESPUESTA_OK) {
        this.router.navigate(['/login']);
      } else {
        this.toastr.error(response.mensaje, '', this.setOptionsToat());
      }
    }, (error: Error) => {
      console.log(error.message);
      this.toastr.error(this.settingService.getMensaje('C0062'), 'Error: ', this.setOptionsToat());
    })
  }

  changePassword () {
    this.changePwdService.parametro = '1'
    this.router.navigate(['/change-password']);
  }

  setOptionsToat() {
    return {
      timeOut: 10000,
      progressBar: true,
      closeButton: true
    }
  }
}
